import { useQuery } from '@tanstack/react-query';

import bundlesService from '~/services/cruises/BundlesService';

import { bundleQueryKeys } from './bundleQueryKeys';

export function useGetBundle(bundleId: string) {
  return useQuery({
    queryKey: bundleQueryKeys.detail(bundleId),
    queryFn: () => bundlesService.getById(bundleId),
    enabled: !!bundleId,
  });
}
